if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.addButton = this.querySelector('.js-sticky-atc-add');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      if (this.addButton) {
        this.addButton.addEventListener('click', this.handleAddClick.bind(this));
        this.observeSubmitButton();
      }
    }

    /**
     * Forwards a click on the sticky bar's "Add to cart" button to the main
     * product form's submit button, so the existing AJAX add-to-cart flow
     * (loading state, cart drawer, errors) runs without duplicating it here.
     */
    handleAddClick() {
      if (this.addButton.getAttribute('aria-disabled') === 'true') return;

      const submitBtn = this.productForm && this.productForm.querySelector('[name="add"]');
      if (submitBtn) submitBtn.click();
    }

    /**
     * Mirrors the main product form's submit button loading/success classes
     * onto the sticky bar's button, so it shows the same spinner/checkmark
     * feedback as the main "Add to cart" button when clicked.
     */
    observeSubmitButton() {
      if (!('MutationObserver' in window) || !this.productForm) return;

      const submitBtn = this.productForm.querySelector('[name="add"]');
      if (!submitBtn) return;

      const syncState = () => {
        this.addButton.classList.toggle('is-loading', submitBtn.classList.contains('is-loading'));
        this.addButton.classList.toggle('is-success', submitBtn.classList.contains('is-success'));
      };

      new MutationObserver(syncState).observe(submitBtn, { attributes: true, attributeFilter: ['class'] });
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
